import {enableProdMode, importProvidersFrom, LOCALE_ID} from '@angular/core'
import {environment} from './environments/environment'
import {bootstrapApplication, BrowserModule, HAMMER_GESTURE_CONFIG, HammerModule} from '@angular/platform-browser';
import {HammerGestureCustomConfig} from './app/config/hammer-gesture-custom.config';
import {
  HTTP_INTERCEPTORS,
  HttpClientModule,
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi
} from '@angular/common/http';
import {httpRequestInterceptor} from './app/interceptors/http-request-interceptor';
import {StatutLabelPipe} from './app/pipes/statut-label.pipe';
import {routes} from './app/app.routes';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule, registerLocaleData} from '@angular/common';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {NgxSliderModule} from '@angular-slider/ngx-slider';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgSelectModule} from '@ng-select/ng-select';
import {ModalModule} from 'ngx-bootstrap/modal';
import {ToastrModule} from 'ngx-toastr';
import {OAuthModule} from 'angular-oauth2-oidc';
import {ServiceWorkerModule} from '@angular/service-worker';
import {AppComponent} from './app/app.component';
import localeFr from '@angular/common/locales/fr'
import {provideRouter, withInMemoryScrolling, withRouterConfig} from "@angular/router";


registerLocaleData(localeFr)

if (environment.production) {
  enableProdMode()
}

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes,
      withRouterConfig({
        onSameUrlNavigation: 'reload'
      }),
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
      })
    ),
    provideHttpClient(withInterceptors([httpRequestInterceptor])),
    importProvidersFrom(BrowserModule, FormsModule, ReactiveFormsModule, HammerModule, CommonModule, NgbModule, NgxSliderModule, BrowserAnimationsModule, NgSelectModule, ModalModule.forRoot(), ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-bottom-center',
      closeButton: true,
      progressBar: true,
    }), OAuthModule.forRoot({
      resourceServer: {
        allowedUrls: [environment.baseUrl],
        sendAccessToken: false,
      },
    }), ServiceWorkerModule.register('custom-service-worker.js', {
      enabled: environment.name != 'local',
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    })),
    {provide: HAMMER_GESTURE_CONFIG, useClass: HammerGestureCustomConfig},
    {provide: LOCALE_ID, useValue: 'fr'},
    StatutLabelPipe,
  ]
})
  .catch((err) => console.error(err))
